export default __webpack_public_path__ + "static/media/favorites-spicy.61af89b4.png";